<template>
    <md-toolbar class="main-toolbar">
        <div class="md-toolbar-container">
            <md-button class="md-icon-button" @click="toggleLeftSidenav">
                <md-icon>menu</md-icon>
            </md-button>
            <div class="md-title">
                <md-avatar class="md-small">
                    <img :src="user.profile_picture" alt="People" v-if="user.profile_picture"/>
                    <img :src="require('../../assets/img/silhouette.jpg')" v-else alt="People"/>
                </md-avatar>
                <span class="avatar-name-role" v-if="user.username">{{user.username}}</span>
                <span class="avatar-name-role" v-else>Cuelist User</span>
            </div>
            <div v-if="fromDashboard">
                <span v-if="isActivePay" class="ql-dashboard-role">Collaborator</span>
                <span v-else class="ql-dashboard-role">Observer</span>
            </div>
            <div class="dashboard-toggles">
                <span class="dark-mode-toggle">
                    <button type="button" class="ql-theme-toggle" @click="toggleShowMode" :aria-label="localShowMode ? 'Switch to light mode' : 'Switch to dark mode'">
                        <span class="ql-theme-toggle-ico">{{ localShowMode ? '☀' : '☾' }}</span>
                        <span>{{ localShowMode ? 'Light' : 'Dark' }}</span>
                    </button>
                </span>
            </div>
            <span style="flex: 1"></span>
            <span v-if="!connected" class="connect-status">Offline</span>
            <img :src="require('../../assets/img/cuelist-full.svg')" alt="cuelisttext" class="main-header-logo" />
        </div>
    </md-toolbar>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/database';
import { mapGetters } from 'vuex';

import NavBus from '@/buses/nav';

const CoreHeader = {
    name: 'CoreHeader',
    props: ['project', 'user', 'locked', 'showMode', 'isActivePay', 'fromDashboard'],
    data: function() {
        return {
            connected: true
        };
    },
    computed: {
        ...mapGetters([
            'currentVersion'
        ]),
        localShowMode() {
            return this.showMode;
        }
    },
    methods: {
        toggleLeftSidenav() {
            NavBus.$emit('main-nav.open');
        },
        toggleShowMode() {
            this.$emit('toggleShowMode');
        },
        handleKeyDown(e) {
            if (e.ctrlKey && e.altKey && e.code === 'KeyD') {
                this.localShowMode = !this.localShowMode;
                this.toggleShowMode();
                e.preventDefault();
            }
        }
    },
    mounted: function () {
        const connectedRef = firebase.database().ref('.info/connected');
        connectedRef.on('value', (snap) => {
            if (snap.val() === true) {
                this.connected = true;
            } else {
                this.connected = false;
            }
        });
        document.addEventListener('keydown', this.handleKeyDown);
    },
    beforeDestroy: function() {
        document.removeEventListener('keydown', this.handleKeyDown);
    }
};
export default CoreHeader;

</script>

<style lang="scss">
.project-version, .project-version-live {
    font-size: 17px;
    font-weight: bold;
    margin-left: 0.5rem;
}

.project-version-live {
    color: rgba(255, 255, 255, .54);
}

.project-version {
    color: #e91e63;
}

.ql-dashboard-header {
    width: 100%;
}
.ql-dashboard-header-pull-right {
    float: right;
}

.dashboard-toggles {
    margin-left: 1rem;
}

.ql-theme-toggle {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: rgba(255, 255, 255, 0.08);
    color: #eaf3f7;
    border: 1px solid rgba(255, 255, 255, 0.16);
    border-radius: 999px;
    padding: 6px 14px;
    font-size: 13px;
    font-weight: 600;
    font-family: inherit;
    cursor: pointer;
}
.ql-theme-toggle:hover { background: rgba(255, 255, 255, 0.16); }
.ql-theme-toggle:focus-visible { outline: none; box-shadow: 0 0 0 3px rgba(115, 213, 227, 0.55); }
.ql-theme-toggle-ico { font-size: 14px; line-height: 1; }

.dark-mode-toggle {
    margin-right: 10px;
}

.ql-dashboard-role {
    font-size: 17px;
    font-weight: bold;
    margin-right: 10px;
    color: rgba(255, 255, 255, .54);
}

.md-toolbar {
    .md-toolbar-container {
        .md-title {
            margin-right: 1rem;
        }
        .main-header-logo {
            height: 42px;
        }
    }
}

.connect-status {
    margin-right: 1em;
}
</style>


// WEBPACK FOOTER //
// header.vue?05248a6a